import React from "react";
import { Grid } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
} from "App/Component/ui";
import { TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import {
  RESET_STATE_FORM_FILTER,
  urlGetGudang,
} from "./helpers";
import DatePicker from "react-datepicker";
import moment from "moment";
import { isNull } from "lodash";
export default function FormFilter({
  formFilter,
  setFormFilter,
  setNewData,
  typeButton = "submit",
  disabledStatus = false,
}) {

  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const gudangUtama = useSelectOption(
    true,
    urlGetGudang,
    TYPE_INSTANCE4,
    "gudangId",
    "name"
  );

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputTextMaster
              name="id"
              label="ID TRANSFER"
              id="id"
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder="Id Transfer"
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="fixasset_id"
              label="ID FIXED ASSET"
              id="fixasset_id"
              value={formFilter.fixasset_id}
              onChange={handleChange("fixasset_id")}
              placeholder="ID Fixed Asset"
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="gudang_sumber_id"
              label="GUDANG SUMBER"
              id="gudang_sumber_id"
              withSearch={true}
              data={gudangUtama}
              value={formFilter.gudang_sumber_id}
              labelValue={formFilter.gudang_sumber}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    gudang_sumber_id: null,
                    gudang_sumber: "Pilih Gudang Sumber",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    gudang_sumber_id: e?.value,
                    gudang_sumber: e?.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="gudang_tujuan_id"
              label="GUDANG TUJUAN"
              id="gudang_tujuan_id"
              withSearch={true}
              data={gudangUtama}
              value={formFilter.gudang_tujuan_id}
              labelValue={formFilter.gudang_tujuan}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    gudang_tujuan_id: null,
                    gudang_tujuan: "Pilih Gudang Tujuan",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    gudang_tujuan_id: e?.value,
                    gudang_tujuan: e?.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="petugas"
              label="PETUGAS"
              id="petugas"
              value={formFilter.petugas}
              onChange={handleChange("petugas")}
              placeholder="Petugas"
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="penerima"
              label="PENERIMA"
              id="penerima"
              value={formFilter.penerima}
              onChange={handleChange("penerima")}
              placeholder="Penerima"
            />
          </Grid>
          <Grid item sm={3}>
            <label htmlFor="date" className="form-control-label">
              TANGGAL AWAL
            </label>

            <DatePicker
              id="date"
              autoComplete="off"
              className="form-control text"
              dateFormat="dd/MM/yyyy"
              timeIntervals={5}
              locale="id-ID"
              selected={moment(formFilter.tglAwal).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                });
              }}
              placeholderText="Tanggal"
            />
          </Grid>
          <Grid item sm={3}>
            <label htmlFor="date" className="form-control-label">
              TANGGAL AKHIR
            </label>

            <DatePicker
              id="date"
              autoComplete="off"
              className="form-control text"
              dateFormat="dd/MM/yyyy"
              timeIntervals={5}
              locale="id-ID"
              selected={moment(formFilter.tglAkhir).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                });
              }}
              placeholderText="Tanggal"
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            onClick={handleSubmit}
            type={typeButton}
            size={"md"}
          />
        </Grid>
      </form>
    </>
  );
}
